<template>
  <!-- 创建积分优惠券 -->
  <div class="createPlayStep" v-if="isShow">
    <!-- <div class="create_coupons" v-if="isShow"> -->
      <div class="backBox">
        <!-- <img class="pointer" @click="retrunMethod()" src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/back.svg" alt="" /> -->
        <jd-button
          type="blue"
          :styleTextObj="{
            width: '44px',
            height: '24px',
            'line-height': '24px',
            padding: '0 8px',
            'min-width': '44px',
          }"
          @click="retrunMethod()"
          >返回</jd-button
        >
        <template v-if="activityData && activityData.name">
          <span class="backBox_name">{{ activityData.name }}</span>
        </template>
        <template v-else>
          <span
            class="txt"
            v-if="tabActive == 10"
            @change="changeTab(tabActive)"
            >创建积分优惠券</span
          >
          <span class="txt" v-if="tabActive == 9" @change="changeTab(tabActive)"
            >创建积分兑换实物</span
          >
        </template>
      </div>
      <div class="formBox" :class="{ formBox: localStep != 0 }">
        <!-- 步骤条 -->
        <div class="stepBox">
          <el-steps class="bz" :space="300" :active="localStep">
            <el-step title="活动模板" v-if="tabActive != 9"></el-step>
            <el-step title="设置规则"></el-step>
            <el-step title="完成发布"></el-step>
          </el-steps>
        </div>

        <div class="firststep" v-if="localStep == 0 && tabActive != 9">
          <div class="activeEdit_bottom">
            <div class="template">
              <div style="width: 82px; padding-top: 5px">模板类型：</div>
              <div class="template-nav">
                <div
                  class="template-wz pointer"
                  v-for="(item, index) in tempSwitchList"
                  :key="item.id"
                  :class="{ activeTem: index == 0 }"
                  v-show="item.isVisible"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
            <!-- m模板图 -->
            <div class="templateBox">
              <!-- 定制 -->
              <div class="temImg">
                <div
                  class="temImg_content"
                  @click="handleOpen()"
                  style="border: 1px solid #d4e2ff"
                >
                  <div class="temImg_content_img temImg_dz">
                    <div class="temImg_dz_center">
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                      <span>品牌定制</span>
                    </div>
                  </div>
                  <div
                    class="temImg_content_wz"
                    style="background: #eaf1ff"
                  ></div>
                </div>
              </div>
              <!-- 模板 -->
              <div class="temImg" v-for="item in giftList" :key="item.id">
                <div class="temImg_content">
                  <div class="temImg_content_img">
                    <img
                      style="width: 100%; max-height: 380px"
                      :src="item.templateUrl"
                      alt=""
                    />
                  </div>
                  <div class="temImg_content_wz">
                    <span class="temImg_title">{{ item.imageName }}</span>
                    <span class="temImg_desc">模板ID：{{ item.id }}</span>
                  </div>
                </div>
                <!-- hover -->
                <div class="temImg_content_bgshadow">
                  <div
                    class="temImg_content_bgshadow_code qrCodeIMG"
                    id="qrCodeIMG1"
                    ref="qrCodeIMG1"
                  ></div>
                  <div class="temImg_content_bgshadow_codeDesc">
                    手机扫码预览模板
                  </div>
                  <div
                    class="temImg_content_bgshadow_btn pointer"
                    @click="nextStepKai(item)"
                  >
                    使用此模板
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="localStep == 1 || tabActive == 9">
          <!-- 兑换表单 -->
          <main class="main">
            <span
              style="
                color: red;
                line-height: 40px;
                font-size: 14px;
                margin-left: 40px;
              "
              v-if="tabActive == 9"
              >温馨提示：实物礼品系统帮助收集消费者的邮寄地址，商家自己线下发货，商家承担运费。</span
            >
            <el-form
              :model="form"
              :rules="rules"
              ref="form"
              label-width="140px"
            >
              <el-form-item label="礼品名称:" v-if="tabActive == 10" required>
                <el-input
                  v-model="form.activityName"
                  maxlength="15"
                  show-word-limit
                  placeholder="请填入活动名称"
                  style="width: 320px"
                ></el-input>
              </el-form-item>

              <el-form-item label="礼品名称:" v-if="tabActive == 9" required>
                <el-input
                  v-model="form.activityName"
                  maxlength="15"
                  show-word-limit
                  placeholder="请填入活动名称"
                  style="width: 320px"
                ></el-input>
                <!-- <jd-button
                  type="break"
                  style="margin-left: 80px"
                  @click="dialogForm"
                  :disabled="isDisabled"
                  >选择本店商品</jd-button
                > -->
                <jd-button
                  type="blue"
                  style="margin-left: 80px"
                  @click="openPrize"
                  :disabled="isDisabled"
                  >选择奖品</jd-button
                >
              </el-form-item>
              <!-- 活动对象 -->
              <informationForm
                v-if="tabActive == 10"
                @selectPeopleSure="selectPeopleSure"
                @getMemberFn="resetMemberFn"
                :defaultActMember.sync="form.ruleDTO.activityTargetType"
                :plusObject.sync="form.ruleDTO.plusObject" 
                :isCheckOpenCardTime.sync="form.ruleDTO.isCheckOpenCardTime" 
                :openCardStartTime.sync="form.ruleDTO.openCardStartTime" 
                :openCardEndTime.sync="form.ruleDTO.openCardEndTime" 
                :peopleSelected.sync="peopleSelected"
                v-model="form.ruleDTO"
                :activityId="9"
                :localStepNum="16"
                :isEdit="false"
                :disabled="false"
                :needNonMember="true"
                :showOpenCardTip="true"
                :basicInformation="false"
                :customerPaperwork="customerPaperwork"
                :isCrowdTextDisabled="isEdit && !isCopy"
                @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
              >
              </informationForm>
              <el-form-item label="礼品价值:" v-if="tabActive == 9">
                <el-input
                  v-model="form.price"
                  @input="
                    (form.price = getNumberData(1, $event, 1, 0)), updata()
                  "
                  show-word-limit
                  style="width: 136px"
                  :disabled="isDisabled"
                ></el-input
                >&nbsp;元
              </el-form-item>

              <el-form-item label="礼品图片:" v-if="tabActive == 9" required>
                <div></div>
                <el-upload
                  ref="upload"
                  action="#"
                  list-type="picture-card"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :http-request="httpRequest"
                  :disabled="isDisabled"
                >
                  <img
                    v-if="(form.wareId || form.isGoodManage) && form.logo"
                    :src="form.logo"
                    style="width: 146px; height: 146px"
                  />
                  <i class="el-icon-plus" v-else></i>
                </el-upload>
                <span style="color: red; font-size: 14px"
                  >建议尺寸：750*420像素，图片大小不能超过1.5MB，类型：JPG、PNG</span
                >
              </el-form-item>
              <!-- 活动对象 -->
              <informationForm
                v-if="tabActive == 9"
                @selectPeopleSure="selectPeopleSure"
                @getMemberFn="resetMemberFn"
                :defaultActMember.sync="form.ruleDTO.activityTargetType"
                :plusObject.sync="form.ruleDTO.plusObject" 
                :isCheckOpenCardTime.sync="form.ruleDTO.isCheckOpenCardTime" 
                :openCardStartTime.sync="form.ruleDTO.openCardStartTime" 
                :openCardEndTime.sync="form.ruleDTO.openCardEndTime" 
                :peopleSelected.sync="peopleSelected"
                v-model="form.ruleDTO"
                :activityId="9"
                :localStepNum="16"
                :isEdit="isDisabled"
                :disabled="isDisabled"
                :needNonMember="true"
                :showOpenCardTip="true"
                :basicInformation="false"
                :customerPaperwork="customerPaperwork"
                :isCrowdTextDisabled="isEdit && !isCopy"
                @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
              >
              </informationForm>
              <template v-if="tabActive == 9">
                <el-form-item label="参与条件：">
                  <div>
                    <el-radio-group v-model="form.ruleDTO.exchangeConditions" :disabled="isDisabled">
                      <el-radio :label="0">满足参与身份即可参与</el-radio>
                      <el-radio :label="1">先下单后参与</el-radio>
                    </el-radio-group>
                  </div>
                  <div
                    v-if="form.ruleDTO.exchangeConditions == 1"
                    class="mt16"
                    style="padding: 20px 0; background-color: #f2f2f2"
                  >
                    <el-form-item label="下单时间：" required>
                      <div class="my_select_time">
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="form.ruleDTO.orderStartTime"
                          type="datetime"
                          placeholder="选择日期时间"
                          size="small"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          style="width: 150px; font-size: 12px"
                          class="time1"
                          :clearable="false"
                          :disabled="isDisabled"
                          :picker-options="{
                            disabledDate(time) {
                              return (
                                form.ruleDTO.orderEndTime &&
                                time.getTime() >
                                  new Date(form.ruleDTO.orderEndTime).getTime()
                              );
                            },
                          }"
                        >
                        </el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="form.ruleDTO.orderEndTime"
                          type="datetime"
                          placeholder="选择日期时间"
                          size="small"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          style="width: 160px; font-size: 12px"
                          class="time2"
                          :clearable="false"
                          :disabled="isDisabled"
                          :picker-options="{
                            disabledDate(time) {
                              return (
                                (form.endTime &&
                                  time.getTime() >
                                    new Date(form.endTime).getTime()) ||
                                time.getTime() <
                                  new Date(form.ruleDTO.orderStartTime).getTime()
                              );
                            },
                          }"
                        >
                        </el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          @click="form.ruleDTO.orderEndTime = '';form.ruleDTO.orderStartTime ='y'"
                        ></i>
                        <img
                          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                          alt=""
                          class="date_icon2"
                        />
                      </div>
                    </el-form-item>
                    <el-form-item label="金额统计类型：" required>
                      <el-radio-group v-model="form.ruleDTO.orderPaymentType" :disabled="isDisabled">
                        <el-radio :label="0" v-if="venderType!=1">实付金额</el-radio>
                        <el-radio :label="1">订单金额</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="商品要求：" required>
                      <div class="flexc-cen-x">
                        <el-radio-group 
                          v-model="form.ruleDTO.filterType" 
                          :disabled="isDisabled"
                          @change="form.ruleDTO.filterType == 0 ? itemListForFilter = [] : ''"
                        >
                          <el-radio :label="0">全部商品</el-radio>
                          <el-radio :label="1">指定商品</el-radio>
                          <el-radio :label="2">排除商品</el-radio>
                        </el-radio-group>
                        <jd-button 
                          class="ml12" 
                          :disabled="form.ruleDTO.filterType == 0 || isDisabled"
                          @click="selectGoodsState = true"
                        >
                          已选择{{ isDisabled ? form.ruleDTO.skuIdList && form.ruleDTO.skuIdList.length : itemListForFilter.length }}个
                        </jd-button>
                      </div>
                      <div class="mt16" v-if="form.ruleDTO.filterType == 1">
                        <el-select
                          v-model="form.ruleDTO.filterSkuType"
                          :disabled="isDisabled"
                          placeholder="请选择"
                          style="width: 320px"
                        >
                          <template v-if="form.ruleDTO.filterType == 1">
                            <el-option label="只要订单包含指定商品就整单计算" :value="0" />
                            <el-option label="仅统计订单内指定商品的金额和件数" :value="1" />
                          </template>
                        </el-select>
                      </div>
                    </el-form-item>
                    <el-form-item label="商品件数：">
                      <el-input
                        v-model="form.ruleDTO.itemLimitCount"
                        :disabled="isDisabled"
                        @input="
                          form.ruleDTO.itemLimitCount = getNumberData(
                            1,
                            $event,
                            0,
                            1,
                            99999,
                          )
                        "
                        style="width: 120px"
                        placeholder="请输入"
                      />
                      <span class="ml6">件及以上</span>
                    </el-form-item>
                    <el-form-item label="订单金额：" required>
                      <el-input
                        v-model="form.ruleDTO.orderPaymentLimit"
                        :disabled="isDisabled"
                        @input="
                          form.ruleDTO.orderPaymentLimit = getNumberData(
                            1,
                            $event,
                            1,
                            0,
                            9999999,
                          )
                        "
                        style="width: 120px"
                        placeholder="请输入"
                      />
                      <span class="ml6">元及以上</span>
                    </el-form-item>
                    <el-form-item label="订单状态：" required>
                      <el-radio-group v-model="form.ruleDTO.orderType" :disabled="isDisabled">
                        <el-radio :label="0">已付款</el-radio>
                        <el-radio :label="1">已完成</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="统计规则：" required>
                      <el-radio-group v-model="form.ruleDTO.orderCountType" :disabled="isDisabled">
                        <el-radio :label="0">按单笔订单统计</el-radio>
                        <el-radio :label="1">按累计订单统计</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="下单跳转链接：">
                      <div>
                        <el-radio-group v-model="form.ruleDTO.goShopSetting" :disabled="isDisabled">
                          <el-radio :label="0">进入店铺首页</el-radio>
                          <el-radio :label="1">跳转指定小程序</el-radio>
                          <el-radio :label="2">进入指定链接</el-radio>
                        </el-radio-group>
                      </div>
                    <div class="mt16">
                      <el-form-item
                        v-if="form.ruleDTO.goShopSetting == 1"
                        label="小程序appId："
                        required
                      >
                        <el-input
                          v-model="form.ruleDTO.goShopAppId"
                          :disabled="isDisabled"
                          placeholder="请输入小程序appId"
                          style="width: 320px"
                        />
                      </el-form-item>
                      <el-form-item
                        v-if="form.ruleDTO.goShopSetting != 0"
                        :label="
                          form.ruleDTO.goShopSetting == 1
                            ? '页面路径path:'
                            : '指定链接：'
                        "
                        :required="form.ruleDTO.goShopSetting == 2"
                      >
                        <div>
                          <el-input
                            v-model="form.ruleDTO.goShopUrl"
                            :disabled="isDisabled"
                            placeholder="请输入"
                            style="width: 320px"
                          />
                        </div>
                        <div style="color: red; font-size: 12px">
                          {{
                            form.ruleDTO.goShopSetting == 1
                              ? "注意：path若不写，则默认进入小程序主页"
                              : "注意：仅可填写京东域内的H5页面地址，不可设置外链。参考链接：https://m.jd.com/。"
                          }}
                        </div>
                      </el-form-item>
                    </div>
                    </el-form-item>
                  </div>
                </el-form-item>
              </template>
              <el-form-item label="添加优惠券:" v-if="tabActive == 10" required>
                <jd-button
                  style="margin-right: 8px"
                  @click="onShowAddCoupon()"
                  :disabled="isDisabled"
                  v-if="butActive == 1"
                >
                  添加优惠券
                </jd-button>
                <div v-if="butActive == 2 && venderType == false">
                  <div class="couponContent">
                    <div class="txtNum">
                      ￥
                      <span style="font-size: 36px; color: #fe4d45">{{
                        couponTxt.discount
                      }}</span>
                    </div>
                    <!-- couponKind 2是店铺券，3是商品券 -->
                    <div class="txtSize">
                      满 {{ couponTxt.quota }} 元可使用 <br />
                      {{ couponTxt.couponKind == 2 ? "店铺券" : "商品券" }}
                    </div>
                    <p class="time">
                      <!-- 有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }} -->
                       <span v-if="couponTxt.validityType == 5">
                        有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }}
                       </span>
                       <span v-else>
                         领取后{{ couponTxt.addDays }}天有效
                       </span>
                    </p>
                    <div class="background"></div>
                    <div class="btn">
                      <jd-button @click="createActivity" type="break" :disabled="isDisabled"
                        >重新选择</jd-button
                      >
                    </div>
                  </div>
                  <p class="pContent">优惠券名称：{{ couponTxt.name }}</p>
                  <p class="pContent">发行量：{{ couponTxt.num }}</p>
                  <br />
                  <p class="pContent">
                    领券开始时间：{{ couponTxt.tekeBeginTime }}
                  </p>
                  <p class="pContent">
                    领券结束时间：{{ couponTxt.takeEndTime }}
                  </p>
                  <br />
                  <p class="pContent">
                    限领规则：{{
                      couponTxt.takeRule == 5
                        ? "活动期间限领一张"
                        : "每天限领一张"
                    }}
                  </p>
                </div>

                <div v-if="butActive == 2 && venderType == true">
                  <div class="couponContent">
                    <div class="txtNum">
                      ￥
                      <span style="font-size: 36px; color: #fe4d45">{{
                        couponTxt.discount
                      }}</span>
                    </div>
                    <div class="txtSize">
                      满 {{ couponTxt.quota }} 元可使用 <br />
                      {{ couponTxt.couponKind == 2 ? "店铺券" : "商品券" }}
                    </div>
                    <p class="time">
                      <!-- 有效期:{{ couponTxt.startTime }}~{{ couponTxt.endTime }} -->
                                    <span v-if="couponTxt.validityType == 5">
                        有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }}
                       </span>
                       <span v-else>
                         领取后{{ couponTxt.addDays }}天有效
                       </span>
                    </p>
                    <div class="background"></div>
                    <div class="btn">
                      <!-- <el-button
                        @click="butActive = 1"
                        type="primary"
                        size="small"
                        >取消</el-button
                      > -->
                      <jd-button @click="createActivity" type="break" :disabled="isDisabled"
                        >重新选择</jd-button
                      >
                    </div>
                  </div>
                  <p class="pContent">优惠券名称：{{ couponTxt.name }}</p>
                  <p class="pContent">发行量：{{ couponTxt.num }}</p>
                  <br />
                  <p class="pContent">
                    领券开始时间：{{ couponTxt.takeBeginTime }}
                  </p>
                  <p class="pContent">
                    领券结束时间：{{ couponTxt.takeEndTime }}
                  </p>
                  <br />
                  <p class="pContent">
                    限领规则：{{
                      couponTxt.takeRule == 5
                        ? "活动期间限领一张"
                        : "每天限领一张"
                    }}
                  </p>
                </div>
              </el-form-item>

              <el-form-item :label="tabActive == 9 ? '兑换次数限制:' : '每人限兑次数:'" required>
                <div class="limitBox">
                  <template v-if="tabActive == 9">
                    <span>活动期间每人每天最多可以兑换</span>
                    <el-input
                      v-model="form.exchangeDayTimes"
                      placeholder="不限制"
                      @input="
                        (form.exchangeDayTimes = getNumberData(1, $event, 0, 0 , 999999)),
                          updata()
                      "
                      style="width: 100px;margin: 0 6px;"
                      :disabled="isDisabled"
                    ></el-input>
                    <span>次，累计每人最多可以兑换</span>
                  </template>
                  <el-input
                    v-model="form.exchangeTimes"
                    placeholder="不限制"
                    @input="
                      (form.exchangeTimes = getNumberData(1, $event, 0, 0 ,999999)),
                        updata()
                    "
                    style="width: 100px;margin: 0 6px"
                    :disabled="isDisabled"
                  ></el-input
                  >&nbsp;次
                  <div style="color: red;">注:每日兑换数量限制不可大于最多兑换限制数量，未填写数量则表示不限</div>
                  <!-- <div style="width: 150px; margin-left: 8px">
                    <jd-tip color="yello" style="padding: 0 9px">
                      <div>不填则默认不限</div>
                    </jd-tip>
                  </div> -->
                </div>
              </el-form-item>
              <!-- required -->
              <el-form-item label="发放数量:" v-if="tabActive == 9" required>
                <span>活动期间每日最多可兑换</span>
                <el-input
                  v-model="form.exchangeNumPerDay"
                  placeholder="不限制"
                  @input="
                    (form.exchangeNumPerDay = getNumberData(1, $event, 0, 0, 999999)),
                      updata()
                  "
                  style="width: 100px;margin: 0 6px"
                  :disabled="isDisabled"
                ></el-input>
                <span>次，累计最多可兑换</span>
                <el-input
                  v-model="form.quantityTotal"
                  placeholder="请输入"
                  @input="
                    (form.quantityTotal = getNumberData(1, $event, 0, 0, 999999)),
                      updata()
                  "
                  style="width: 100px;margin: 0 6px"
                  :disabled="isDisabled"
                ></el-input>
                <span>次</span>
              </el-form-item>

              <el-form-item label="上下架时间:" required>
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form.startTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 135px; font-size: 12px"
                    class="time1"
                    @change="activityTimeChange"
                    :picker-options="pickerOptionsValue"
                    :clearable="false"
                    :disabled="isDisabled && tabActive == 10"
                  >
                  </el-date-picker>
                  <div class="time_to_text">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form.endTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 150px; font-size: 12px"
                    class="time2"
                    @change="activityTimeChange"
                    :clearable="false"
                    :disabled="isDisabled && tabActive == 10"
                  >
                  </el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="clearTime()"
                  ></i>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                    alt=""
                    class="date_icon2"
                  />
                </div>
                <span class="lastTime">
                  活动持续
                  <span style="color: #fe4d45">{{ timeDay }}</span> 天
                  <span style="color: #fe4d45">{{ timeOut }}</span> 小时
                </span>
              </el-form-item>

              <el-form-item label="兑换所需等级:" required>
                <div class="level-wrap">
                  <el-checkbox-group
                    v-model="memberLe"
                    @change="checkListchange"
                    :disabled="isDisabled"
                  >
                    <el-checkbox :label="memberLe">全部</el-checkbox>
                  </el-checkbox-group>
                  <el-checkbox-group
                    v-model="level"
                    v-for="(item, index) in memberLevelList"
                    :key="index"
                    @change="checkTheChange"
                    :disabled="isDisabled"
                  >
                    <el-checkbox
                      :label="item.value"
                      :disabled="memberLe == true"
                      v-if="item.label"
                      >{{ item.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
              </el-form-item>

              <el-form-item label="兑换所需积分:" required>
                <div class="isLevelSet" style="width: 600px">
                  <template v-if="!isLevelSet">
                    <el-input
                      v-model.number="form.memberLevelPoints"
                      @input="
                        (form.memberLevelPoints = getNumberData(
                          1,
                          $event,
                          0,
                          0
                        )),
                          updata();
                      "
                      style="width: 136px; margin-right: 20px"
                      :disabled="isDisabled"
                    ></el-input>
                  </template>
                  <template v-else>
                    <ul class="levelList">
                      <li
                        class="item"
                        v-for="item in memberLevelList"
                        :key="item.value"
                      >
                        {{ item.label }}
                        <el-input
                          v-model.number="item.point"
                          placeholder="请输入..."
                          @input="
                            (item.point = getNumberData(1, $event, 0, 0)),
                              updata()
                          "
                          style="width: 80px"
                          :disabled="isDisabled"
                        ></el-input>
                        积分
                      </li>
                    </ul>
                  </template>
                  <jd-button type="break" @click="isLevel" :disabled="isDisabled">
                    {{ isLevelSet == false ? "按会员等级设置" : "统一设置" }}
                  </jd-button>
                </div>
              </el-form-item>
              <el-form-item label="屏蔽发货地址:" v-if="tabActive==9">
                <jd-button @click="handleSelectCity" :disabled="isDisabled">已选择省市（{{addressList.length}}）</jd-button>
              </el-form-item>
              <el-form-item label="是否支持撤回奖品:" v-if="tabActive==9" label-width="140px">
                <el-radio-group v-model="form.supportRollback" @change="updata" :disabled="isDisabled">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- <div class="pd20">
                <jd-title label="展示店铺"></jd-title>
              </div> -->
              <!-- <el-form-item label="小程序店铺信息：" v-if="tabActive != 9" label-width="150px">
                  <el-radio-group v-model="customerPaperwork.shopNameType">
                      <el-radio :label="0">统一显示配置店铺</el-radio>
                      <el-radio :label="2">不显示店铺信息</el-radio>
                  </el-radio-group>
              </el-form-item> -->
              <activityPageSettings
                isShowShopName
                v-model="customerPaperwork"
                class="activityPageSettings-preview"
                v-if="tabActive == 9"
                style="width: calc(100% - 10px)"
                :isNeedCustomerPaperworkData="false" 
                :giftList="giftList" 
                templatekey="templateUrl" 
                :templateId="form.templateId"
                designSpecificationsUrl="https://cdn-image.yucrm.cn/dc922076e4f4492ab81f436652a4ded2.png"
                :isNeedSetBG="form.templateId != 0"
                :cusTemplateJSON.sync="form.cusTemplateJson"
                isCustomPreview
                widthNumber="750"
                heightNumber="1650"
                downloadTemplateUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/积分兑换实物.psd"
                @cusTemplateJSONChange="cusTemplateJson = $event"
                @selectTemplate="form.templateId = giftList[$event].id"
              >
                <template #customPreview>
                  <div class="big-box-preview">
                  <div
                    class="scroll-box"
                    :style="{
                      backgroundImage: `url(${
                        form.templateId == '0'
                          ? giftList[0] && giftList[0].templateUrl
                          : cusTemplateJson && cusTemplateJson.activityBgImg
                          ? cusTemplateJson.activityBgImg
                          : giftList.find((item) => item.id == form.templateId) &&
                            giftList.find((item) => item.id == form.templateId).url
                      })`,
                    }"
                  >
                      <template v-if="form.templateId != 0">
                        <div class="header">
                          <img style="width: 100%;" src="https://cdn-image.yucrm.cn/images/tb/funGamesImg/header.png" />
                        </div>
                        <div class="goods-info">
                          <div class="goods-detail">
                            <div class="goods-detail-img">
                              <img :src="form.logo" alt="" />
                            </div>
                            <div class="goods-detail-info">
                              <div class="goods-detail-name">
                                {{ form.activityName || "" }}
                              </div>
                              <div class="goods-detail-amount">
                                剩余{{ form.quantityTotal || 0 }}份
                              </div>
                              <div class="goods-detail-price-box">
                                <div class="point">
                                  <span>{{ form.memberLevelPoints || 0 }}</span>
                                  <span style="font-size: 13px;font-weight: 400;">积分</span>
                                </div>
                                <div class="old-price">
                                  ￥{{ form.price || 0 }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="goodsc-car-line"></div>
                          <div class="goods-des">
                            <span>送至</span>
                            <span>某某市某某区某某街道某某号</span>
                          </div>
                          <div class="goods-des">
                            <span>运费</span>
                            <span>包邮</span>
                          </div>
                        </div>
                        <div class="rule-title">
                          兑换规则
                        </div>
                        <div class="rule-infos">
                          {{ form.ruleDescription || "" }}
                        </div>
                        <div class="handler-btns">
                          <div>
                            兑换记录
                          </div>
                          <div>
                            立即兑换
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="title">
                    图为预览效果，以实际投效果为准
                  </div>
                </template>
              </activityPageSettings>

              <el-form-item label="规则说明:" required>
                <div
                  style="
                    width: 720px;
                    backgroundcolor: rgba(250, 250, 250, 1);
                    padding-top: 8px;
                  "
                >
                  <el-input
                    type="textarea"
                    class="textarea"
                    style="width: 704px"
                    resize="none"
                    :rows="6"
                    v-model="form.ruleDescription"
                    @input="updata"
                  ></el-input>

                  <div style="margin-top: 8px">
                    <jd-button type="blue" @click="generativerule"
                      >生成规则</jd-button
                    >
                    <span class="txt" style="margin-left: 8px"
                      >点击按钮自动生成规则，也可以自己编辑信息</span
                    >
                  </div>
                </div>
              </el-form-item>
              <!-- 新增字段 -->
              <el-form-item label="是否重点活动:" required>
                <div class="flexc-cen-x mt10">
                  <el-radio-group v-model="isKeyActivity" :disabled="isDisabledNew">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <template slot="content">
                      <div>
                        大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
                      </div>
                    </template>
                    <i class="new-icon-box ml8"></i>
                  </el-tooltip>
                </div>
              </el-form-item>
              <el-form-item label="活动投放位置:" required>
                <el-checkbox-group v-model="placementPosition" :disabled="isDisabledNew">
                  <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
                  <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
                  <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
                  <el-checkbox label="SHOP">店铺</el-checkbox>
                  <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
                  <el-checkbox label="OTHER">其他渠道</el-checkbox>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <template slot="content">
                      <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
                    </template>
                    <i class="new-icon-box ml8"></i>
                  </el-tooltip>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </main>

          <!-- 添加优惠券 -->
          <add-coupon
            :isShow="addCouponIsShow"
            @close="addCouponIsShow = false"
            @funcMes="addStatus"
          ></add-coupon>

          <!-- 自营=====添加优惠券 -->
          <self-support-addCoupon
            :isShow="selfSupportAddCouponIsShow"
            @close="selfSupportAddCouponIsShow = false"
            @funcMes="addStatusCoupon"
          ></self-support-addCoupon>
        </div>
      </div>
      <div class="create_bottom" v-if="localStep != 0 || tabActive == 9">
        <jd-button @click="retrunMethod()">返回上一页</jd-button>
        <jd-button
          @click="saveDraft"
          style="margin-left: 8px"
          v-if="hasDraftBtn"
          >存为草稿</jd-button
        >
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="setActivity"
          v-preventReClick
        >
          保存并完成设置
        </jd-button>
      </div>
      <!-- 选择商品弹窗 -->
      <el-dialog
        title="选择商品"
        :visible.sync="dialogFormVisible"
        width="820px"
      >
        <input-form
          :inputData="commodityList"
          @toParentVal="searchContent"
          :immediately="true"
        ></input-form>
        <div class="new-table-box" style="margin-top: 20px">
          <el-table
            :data="tableShopData"
            stripe
            style="width: 100%; margin: 0 auto"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column width="100">
              <template slot-scope="scope">
                <img
                  :src="scope.row.logo"
                  class="avar"
                  alt="商品图片"
                  style="height: 60px; width: 60px"
                />
              </template>
            </el-table-column>
            <el-table-column prop="skuName" label="商品名称" width="300">
              <template slot-scope="scope">
                <a :href="scope.row.itemUrl" target="_blank"
                  >{{ scope.row.skuName }}<br />
                  ¥{{ scope.row.jdPrice }}</a
                >
              </template>
            </el-table-column>
            <el-table-column prop="skuId" label="SKU ID" width="200">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <jd-button type="blueText" @click="chooseShop(scope.row)" v-loading="sureLoading"
                  >选择</jd-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="new-pagination-page" style="margin-top: 16px">
          <el-pagination
            style="text-align: right"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 30, 50, 100]"
            :page-size="5"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalList"
          ></el-pagination>
        </div>
      </el-dialog>
      <!-- 选择优惠券 -->
      <selectPrize v-model="dialogPrize" @closePrize="closePrize"></selectPrize>
          <!-- 自定义城市弹窗 -->
    <city-popover
      v-model="isShowCity"
      @on-change="getLocation"
      :checkedList="addressList"
    ></city-popover>
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="itemListForFilter"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="isEdit"
      isInteract
    ></selectGoodsMonitor>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      defaultSelect="third"
      :isShowJingdou="false"
      :isShowCoupon="false"
      :isShowManage="false"
      :hideShopPoints="true"
      :isShowEK="false"
      :isShowIQY="false"
      :isShowPLUS="false"
      :isShowHongBao="false"
      :isShowGiftCard="false"
      :hideExclusive="true"
      :isShowDirectlyFill="false"
      @choose-shop="getTheData"
    >
    </selectProduct>
    </div>
  <!-- </div> -->
</template>

<script>
import selectPrize from "./select_prize.vue";
import addCoupon from "./add_coupon.vue";
import selfSupportAddCoupon from "./selfSupport_add_coupon.vue"; //自营
import inputForm from "@/components/jhk/inputForm";
import {
  querydetail,
  closeSellerCouponWrite,
} from "@/api/jhk/integralCenter/couponWriteController.js";
import QRCode from "qrcodejs2";
import {
  getTaobaoItemListSku,
  getSellercats,
} from "@/api/jhk/analysis/ware-controller.js";

import {
  setActivityList,
  uploadpic,
  setActivityVenderType,
  inquireActivity,
  changeActivity,
  sellerImage,
  updateActivity,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { getSkuList } from "@/api/member/pointsManagement.js"
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import cityPopover from "@/components/city-popover-x.vue";
import activityPageSettings from "./components/activityPageSettings.vue"
import { checkProduct } from "@/api/jhk/activity.js";
import informationForm from "@/views/interactiveMarketing/activity/components/informationForm.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import selectProduct from "./select_product.vue";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    stepNum: {
      type: Number,
      default: 0,
    },
    tabActive: {
      type: Number,
      default: 10,
    },
    valueRow: null,
    activityData: {},
    isStart: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    addCoupon,
    inputForm,
    selfSupportAddCoupon,
    selectPrize,
    cityPopover,
    activityPageSettings,
    informationForm,
    selectGoodsMonitor,
    selectProduct
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.isCopy;
    },
    isEdit() {
      return this.activityData.isEdit
    },
    isDisabled() {
      // 复制场景不置灰
      let isCopy = this.activityData.isCopy || this.activityData.singleCopy
      return this.valueRow && this.valueRow.status == 2 && !isCopy;
    },
    isDisabledNew() {
      let flag = true;
      if(!this.valueRow||JSON.stringify(this.valueRow) == '{}') {
        flag = false
      }
      if(this.valueRow&&this.valueRow.status==5) {
        flag = false
      }
      if(this.activityData&&(this.activityData.isCopy||this.activityData.singleCopy)) {
        flag = false
      }
      if((this.activityData.id==8||this.activityData.id==19||this.activityData.id==50)&&this.activityData.status==5) {
        flag = false
      }
      return flag
    }
  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
    tabActive: {
      handler() {},
      immediate: true,
    },
    activityData: {
      handler() {},
      immediate: true,
      deep: true,
    },
    venderType: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.form.ruleDTO.orderPaymentType = 1;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      itemArr: [],
      prizeList: [],
      JingdouCount: {
        prizeCount: 0,
      },
      echoDate: {},
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      showSelectProduct: false,
      selectGoodsState: false,
      itemListForFilter: [],
      // 1.14迭代 指定入会时间
      // ruleDto:{
      //   plusObject:0, //plus会员
      // },
      sureLoading: false,
      isKeyActivity: 0,
      placementPosition: [],
      isShowCity: false,
      addressList: [],
      localStep: this.stepNum,
      giftList: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf()
          );
        },
      },
      fileList: [],
      memberLevelPointsDTOList: [],
      butActive: 1,
      commodityList: [
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
      // 表单值
      form: {
        logo: "",
        activityName: "",
        ruleDescription: "",
        price: null,
        exchangeTimes: null,
        quantityTotal: null,
        startTime: null,
        endTime: null,
        memberLevelPoints: "",
        couponRedemptionType: "",
        supportRollback: 1, //是否支持撤回奖品
        templateId: "0",
        cusTemplateJson: "",
        prizeGoShop: "",
        ruleDTO: {
          activityTargetType: '1',
          partner: ["-1"],
          allowLevel: "-1",
          plusObject: 0,
          crowdIds: "",
          firstOpenCardTimeType: 0,
          openCardBeforeDay: "",
          orderCompleteLimitCount: "",
          orderCompleteMaxCount: "",
          orderCompleteLimitPayment: "",
          orderCompleteMaxPayment: "",
          lastOrderCompleteTimeType: 0,
          lastOrderCompleteStartDay: "",
          lastOrderCompleteEndDay: "",
          lastOrderCompleteStartTime: "",
          lastOrderCompleteEndTime: "",
          isCheckOpenCardTime: "",
          openCardStartTime: "",
          openCardEndTime: "",
          // 下单条件 start
          exchangeConditions: 0, // 参与条件，0满足参与身份即可参与 1先下单后兑换
          orderStartTime: "", // 下单时间范围起始
          orderEndTime: "", // 下单时间范围结束
          orderPaymentType: 0, // 金额统计类型，0实付金额 1订单金额
          filterType: 0, // 商品要求，0全部商品 1指定商品 2排除商品
          skuIdList: [], // skuId集合
          filterSkuType: 0, // 指定商品规则 0/null:只要订单包含指定商品就整单计算 1:仅统计订单内指定商品的金额和件数
          itemLimitCount: "", // 商品件数及以上
          orderPaymentLimit: "", // 订单金额及以上
          orderType: 0, // 订单状态， 0已付款 1完成
          orderCountType: 0, // 订单门槛统计方式 0 单笔满 1累计满
          goShopSetting: 0, // 下单跳转链接 0进入店铺首页 1跳转指定小程序 2进入指定链接
          goShopAppId: "",
          goShopUrl: "",
          // 下单条件 end
        },
      },
      customerPaperwork: {
        shopNameType: 0,
      },
      level: [],
      memberLevelList: [
        // { value: "全部", label: -1, point: "", levelName: "全部" },
        // { value: "非会员", label: 0, point: "", levelName: "非会员" },
        { value: "一星会员", label: 1, point: "", levelName: "一星会员" },
        { value: "二星会员", label: 2, point: "", levelName: "二星会员" },
        { value: "三星会员", label: 3, point: "", levelName: "三星会员" },
        { value: "四星会员", label: 4, point: "", levelName: "四星会员" },
        { value: "五星会员", label: 5, point: "", levelName: "五星会员" },
      ],
      memberLevelListchange: [],
      // 表单校验
      rules: {
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        quantityTotal: {
          required: true,
          message: "请输入总份数",
          trigger: "blur",
        },
      },
      startTime: null,
      endTime: null,
      isLevelSet: false,
      islabled: false,
      dialogFormVisible: false,
      // 添加优惠券显示隐藏状态控制
      addCouponIsShow: false,
      selfSupportAddCouponIsShow: false,

      //上传图片
      dialogImageUrl: "",
      dialogVisible: false,
      tableShopData: [],
      couponTxt: {},
      totalList: 0,
      currentPage: 1,
      couponId: 0,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      memberLe: true,
      spliceData: 0,
      useFullLevel: [],
      isCopy: false,
      isDraft: false,
      dialogPrize: false,
      cusTemplateJson: {},
      peopleSelected: [],
    };
  },
  mounted() {
    this.getLevel();
    this.init();
    if (!this.valueRow) {
      this.form.startTime = this.$getDate(30)[0];
      this.form.endTime = this.$getDate(30)[1];
      this.activityTimeChange();
    }
  },
  methods: {
    getTheData(data, prizeType) {
      let obj = {
        giftType: "",
        price: "",
        logo: "",
        assetsId: "",
        prizeType: 3,
        title: "",
        skuId: "",
        singleAmount: 1,
        isGoodManage: 0,
        budgetRemain: "",
      }
      if (data.giftType) {
        obj.giftType = Number(data.giftType);
      }
      obj.price = Number(data.discount);

      obj.assetsId = Number(data.couponId || data.skuId);
      obj.logo = data.logo;
      obj.prizeType = prizeType;
      obj.title = data.name;

      if (data.singleAmount) {
        obj.singleAmount = data.singleAmount;
      }
      if (prizeType == 3) {
        obj.skuId = data.skuId;
      }
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          obj.skuId = data.skuId;
          delete obj.isGoodManage
        } else {
          obj.isGoodManage = data.isGoodManage;
          obj.budgetRemain = data.budgetRemain;
        }
      }
      this.prizeList = [obj]
      this.form.activityName = obj.title.substring(0, 15);
      this.form.price = obj.price;
      this.form.prizeType = obj.prizeType;
      if(!this.form.isGoodManage) {
        this.form.wareId = data.categoryId;
      }
      this.form.logo = obj.logo;
      this.form.singleAmount = obj.singleAmount;
      this.form.assetsId = obj.assetsId;
      this.form.isGoodManage = obj.isGoodManage;
      this.form.budgetRemain = obj.budgetRemain;
      this.showSelectProduct = false;
    },
    openPrize() {
      this.itemArr = this.prizeList;
      if(this.prizeList.length) {
        this.JingdouCount.prizeCount = 0;
        this.echoDate = this.prizeList[0];
      }
      this.showSelectProduct = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    selectGoodsClose(data) {
      if (data) {
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
        });
      }
      this.selectGoodsState = false;
    },
    resetMemberFn(val) {
      this.peopleSelected = [];
      this.form.ruleDTO.partner = ["-1"];
      this.form.ruleDTO.firstOpenCardTimeType = 0;
      this.form.ruleDTO.openCardBeforeDay = "";
      this.form.ruleDTO.orderCompleteLimitCount = "";
      this.form.ruleDTO.orderCompleteMaxCount = "";
      this.form.ruleDTO.orderCompleteLimitPayment = "";
      this.form.ruleDTO.orderCompleteMaxPayment = "";
      this.form.ruleDTO.lastOrderCompleteTimeType = 0;
      this.form.ruleDTO.lastOrderCompleteStartDay = "";
      this.form.ruleDTO.lastOrderCompleteEndDay = "";
      this.form.ruleDTO.lastOrderCompleteStartTime = "";
      this.form.ruleDTO.lastOrderCompleteEndTime = "";
      this.form.ruleDTO.plusObject = 0;
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    // 活动模板
    async sellerImage() {
      let params = {
        current: 1,
        size: 999,
        source: 4,
        hdTaskType: 9,
      };
      const { data } = await sellerImage(params);
      const giftList = data.records.map((item) => {
        return {
          ...item,
          templateUrl: item.imageUrl || "",
        };
      });
      this.giftList = [...this.giftList, ...giftList];
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    getLocation(val, state) {
      this.addressList = val;
    },
    handleSelectCity() {
      this.isShowCity = true;
    },
    // 奖品确定
    closePrize(val, params) {
      console.log(params);
      if (val) {
        if (this.venderType && val.couponType == 1) {
          return this.$message.warning("此类型奖品暂时不支持自营店铺！");
        }
        this.butActive = 2;
        this.couponTxt = params;
        this.couponTxt.beginTime = params.takeBeginTime;
        this.couponTxt.endTime = params.takeEndTime;
        if (this.venderType) {
          this.form.quantityTotal = params.num;
        } else {
          this.couponId = Number(params.couponId);
        }
        this.form.prizeGoShop = params.prizeGoShop;
      }
      this.dialogPrize = false;
    },
    updata() {
      this.$forceUpdate();
    },
    init() {
      this.giftList = [
        {
          createTime: "2021-11-08 17:02:20",
          days: "",
          expirationType: 0,
          giftPrizeType: 1,
          giftType: 1,
          id: "0",
          openMerchant: "",
          openType: 0,
          imageName: "",
          templateUrl: "",
          updateTime: "2021-11-12 10:19:55",
          templateUItype: 1,
        },
      ];
      console.log(this.tabActive, this.activityData);
      if (
        this.tabActive == 10 ||
        (this.activityData && this.activityData.id == 10)
      ) {
        this.giftList[0].templateUrl =
          "https://jdminiapp.yucrm.cn/html/images/Preview/yhq.png";
        this.giftList[0].imageName = "积分优惠券";
      } else {
        this.giftList[0].templateUrl =
          "https://jdminiapp.yucrm.cn/html/images/Preview/sw.png";
        this.giftList[0].secondImageUrl =
          "https://jdminiapp.yucrm.cn/html/images/Preview/sw.png";
        this.giftList[0].imageName = "默认模板";
      }
      if(this.tabActive == 9) {
        this.sellerImage();
      }
    },
    // 回显
    getDetail() {
      inquireActivity(this.valueRow.id).then((res) => {
        res.data.memberLevelPoints = "";
        res.data.ruleDTO = res.data.ruleDTO || {
          activityTargetType: '1',
          partner: ["-1"],
          allowLevel: "-1",
          plusObject: 0,
          crowdIds: "",
          firstOpenCardTimeType: 0,
          openCardBeforeDay: "",
          orderCompleteLimitCount: "",
          orderCompleteMaxCount: "",
          orderCompleteLimitPayment: "",
          orderCompleteMaxPayment: "",
          lastOrderCompleteTimeType: 0,
          lastOrderCompleteStartDay: "",
          lastOrderCompleteEndDay: "",
          lastOrderCompleteStartTime: "",
          lastOrderCompleteEndTime: "",
          isCheckOpenCardTime: "",
          openCardStartTime: "",
          openCardEndTime: "",
          filterSkuType: 0,
        };
        if(res.data.ruleDTO.exchangeConditions == null || res.data.ruleDTO.exchangeConditions == undefined) {
          res.data.ruleDTO.exchangeConditions = 0;
          res.data.ruleDTO.orderStartTime = "";
          res.data.ruleDTO.orderEndTime = "";
          res.data.ruleDTO.orderPaymentType = 0;
          res.data.ruleDTO.filterType = 0;
          res.data.ruleDTO.skuIdList = [];
          res.data.ruleDTO.filterSkuType = 0;
          res.data.ruleDTO.itemLimitCount = "";
          res.data.ruleDTO.orderPaymentLimit = ""; 
          res.data.ruleDTO.orderType = 0;
          res.data.ruleDTO.orderCountType = 0;
        } else if (res.data.ruleDTO.exchangeConditions == 1 && res.data.ruleDTO.skuIdList && res.data.ruleDTO.skuIdList.length) {
          getTaobaoItemListSku({
            current: 1,
            size: res.data.ruleDTO.skuIdList.length,
            skuIdStr: res.data.ruleDTO.skuIdList.join(','),
          }).then(res2 => {
            this.itemListForFilter = res2.data.records;
          })
        }
        res.data.ruleDTO.goShopSetting = res.data.ruleDTO.goShopSetting || 0;
        res.data.ruleDTO.partner = res.data.ruleDTO.allowLevel.split(",");
        this.form = res.data;
        if(this.venderType) {
          this.form.ruleDTO.orderPaymentType = 1;
        }
        this.prizeList = [{
          title: res.data.activityName,
          price: res.data.price,
          prizeType: res.data.prizeType,
          wareId: res.data.wareId,
          categoryId: res.data.wareId,
          assetsId: res.data.assetsId,
          isGoodManage: res.data.isGoodManage ? res.data.isGoodManage : 0,
          budgetRemain: res.data.budgetRemain,
          logo: res.data.logo,
          giftType: res.data.giftType || "1",
          prizeType: 3,
        }]
        this.form.ruleDTO.activityTargetType = String(this.form.ruleDTO.activityTargetType);
        this.peopleSelected = res.data.ruleDTO.crowdIds ? res.data.ruleDTO.crowdIds.split(',') : [];
        this.form.ruleDTO.condFollow = this.form.ruleDTO.condFollow ? true : false;
        // 处理是否重点活动
        this.isKeyActivity = res.data.isKeyActivity||0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(',') : ["SHOP"];
        this.form.activityName =
          res.data.activityName + (this.activityData.singleCopy ? "复制" : "");
        this.form.exchangeTimes =
          this.form.exchangeTimes == -1 ? null : this.form.exchangeTimes;
        this.form.startTime = res.data.startTime ? res.data.startTime : null;
        this.form.endTime = res.data.endTime ? res.data.endTime : null;
        if(this.tabActive == 9) {
          this.addressList = res.data.cites ? res.data.cites.split(',') : [];
          this.form.templateId = res.data.templateId || '0';
          
          if(res.data.supportRollback == null || res.data.supportRollback == undefined) {
            this.form.supportRollback = 1;
          } else {
            this.form.supportRollback = res.data.supportRollback;
          }
          this.cusTemplateJson = res.data.cusTemplateJson ? JSON.parse(res.data.cusTemplateJson) : {};
          this.customerPaperwork = res.data.customerPaperwork ? JSON.parse(res.data.customerPaperwork) : { shopNameType: 0 };
        }
        this.activityTimeChange();
        // v2.5 复制需求
        if (!this.activityData.singleCopy) {
          const checkedLevel = res.data.memberLevelPointsDTOList
            .filter((item) => item.allow)
            .map((item) => item.level);
          let allLevel = true;
          let isAll = true;
          this.memberLevelList.forEach((list) => {
            if (!checkedLevel.includes(list.value)) {
              allLevel = false;
            }
          });
          res.data.memberLevelPointsDTOList.forEach((item) => {
            if (item.allow) {
              if (item.point != res.data.memberLevelPointsDTOList[0].point) {
                isAll = false;
              }
            }
          });
          // 全部会员
          if (allLevel) {
            this.memberLe = true;
            this.level = this.memberLevelList.map((item) => item.value);
          } else {
            this.memberLe = false;
            this.level = checkedLevel;
          }
          // 统一设置
          if (isAll) {
            this.isLevelSet = false;
            this.form.memberLevelPoints =
              res.data.memberLevelPointsDTOList[0].point;
          } else {
            this.isLevelSet = true;
            this.memberLevelList.forEach((item) => {
              res.data.memberLevelPointsDTOList.forEach((list) => {
                if (item.value == list.level && list.allow) {
                  item.point = list.point;
                }
              });
            });
          }
        }
        // 查询优惠券
        if (this.tabActive == 10 && res.data.couponId) {
          this.form.prizeGoShop = res.data.prizeGoShop
          querydetail(Number(res.data.couponId)).then((res) => {
            this.butActive = 2;
            this.couponTxt = res.data;
            let sum1 = res.data.beginTime.split(" ");
            let sum2 = res.data.endTime.split(" ");
            this.couponTxt.beginTime = sum1[0];
            this.couponTxt.endTime = sum2[0];
            this.couponId = res.data.couponId;
          });
        }
        if (this.activityData.singleCopy) {
          //规则
          this.form.ruleDescription = "";
          // 复制移除状态
          delete this.form.status;
        }
      });
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      const url = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + this.giftList[index].templateUrl,
        });
      }
    },
    nextStepKai(item) {
      this.localStep = 1;
    },
    onShowAddCoupon() {
      // if (this.venderType == true) {
      //   this.selfSupportAddCouponIsShow = true;
      // } else {
      //   this.addCouponIsShow = true;
      // }
      this.dialogPrize = true;
    },
    isLevel() {
      this.isLevelSet = !this.isLevelSet;
      this.form.memberLevelPoints = "";
      this.memberLevelList.forEach((item) => {
        item.point = "";
      });
    },
    //会员等级
    getLevel() {
      querymemberLevel().then((res) => {
        this.memberLevelList = res.data.map((item) => {
          let obj = {
            value: item.customerLevel,
            label: item.customerLevelName,
            point: "",
          };
          return obj;
        });
        // 默认全部选中
        this.level = res.data.map((item) => item.customerLevel);
        // 复制、跨店复制、草稿编辑
        if (this.valueRow && this.valueRow.id) {
          this.isCopy = this.activityData.singleCopy;
          this.getDetail();
        }
      });
    },
    //输入框限制负数
    checkputn0(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value <= 0) {
        this.$message({
          message: "请填写大于0的数字",
          type: "warning",
        });
        e.target.value = "";
      }
      return e.target.value;
    },
    //输入框限制负数
    checkputn1(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //返回
    retrunMethod() {
      if (this.isCopy && this.localStep != 0) return (this.localStep = 0);
      this.form.activityName = "";
      this.form.logo = "";
      this.form.activityName = "";
      this.form.ruleDescription = "";
      this.form.price = null;
      this.form.exchangeTimes = null;
      this.form.quantityTotal = null;
      this.form.startTime = "";
      this.form.endTime = "";
      this.level = [0, 1, 2, 3, 4, 5];
      this.memberLe = true;
      this.form.memberLevelPoints = "";
      this.form.couponRedemptionType = ""; //v3.9新增
      if (this.localStep == 0 || this.tabActive == 9) this.$emit("return");
      if (this.localStep == 1) this.localStep = 0;
    },
    //活动时间驱动
    activityTimeChange(val) {
      // 校验有无时间
      if (!this.form.endTime || !this.form.startTime) return;
      let nowTime = new Date().getTime();
      let start = new Date(this.form.startTime).valueOf();
      let end = new Date(this.form.endTime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.pointUserInfo.expiredIn
      ).valueOf();
      let hdInvalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiresIn
      ).valueOf();
      if (end > invalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        this.form.endTime = null;
        return;
      }
      if (end > hdInvalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        this.form.endTime = null;
        return;
      }
      if (start < nowTime) {
        // this.$message.warning("开始时间不能小于当前时间");
        // this.form.startTime = null;
        // return;
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.form.endTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.form.endTime = null;
        return;
      }

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.form.startTime.substring(0, 10);
      daysEnd = this.form.endTime.substring(0, 10);
      if (this.form.endTime != "" && this.form.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.form.endTime).getTime() -
          new Date(this.form.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    // 隐藏添加优惠券组件
    addCouponChange() {
      this.addCouponIsShow = false;
      // console.log(111);
    },
    //取消优惠券
    createActivity() {
      if (this.venderType) {
         this.butActive = 1;
         this.onShowAddCoupon()
      } else {
        // 重新选择优惠券不调接口直接重新打开弹窗
          this.butActive = 1;
          this.onShowAddCoupon()
        // let couponId = this.couponId;
        // closeSellerCouponWrite(couponId)
        //   .then((res) => {
        //     if (res && res.code == 1) {
        //       this.butActive = 1;
        //       this.onShowAddCoupon()
        //     } else {
        //       this.$message.error(res.message);
        //     }
        //   })
        //   .catch((res) => {});
      }
    },
    //选中改变
    checkListchange(val) {
      if (val) {
        this.level = this.memberLevelList.map((item) => item.value);
      } else {
        this.level = [];
      }
    },

    checkTheChange(val) {
      if (val.length == 6) {
        this.memberLe = true;
      } else {
        this.memberLe = false;
      }
    },

    //获取优惠券信息
    addStatus(val) {
      console.log("val------>", val);
      this.butActive = 2;
      this.couponId = Number(val);
      querydetail(this.couponId)
        .then((res) => {
          this.couponTxt = res.data;
          let sum1 = res.data.beginTime.split(" ");
          let sum2 = res.data.endTime.split(" ");
          this.couponTxt.beginTime = sum1[0];
          this.couponTxt.endTime = sum2[0];
          // console.log(res);
        })
        .catch((res) => {});
    },

    //自营店铺获取优惠券信息
    addStatusCoupon(data) {
      console.log("data", data);
      this.butActive = 2;
      this.couponTxt = data;
      this.form.quantityTotal = data.num;
      this.couponTxt.startTime = data.startTime;
      this.couponTxt.endTime = data.endTime;
    },

    dialogForm() {
      this.dialogFormVisible = true;
      this.getShopList();
      this.getSeller();
    },
    //获取店铺商品
    getShopList() {
      getSkuList(this.formShopList).then((res) => {
        this.tableShopData = res.data.records;
        this.totalList = res.data.total ? Number(res.data.total) : 0;
      });
    },
    // 获取商品类目
    getSeller() {
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        // console.log(data);
        this.getTrees(data);
        // console.log(data);
        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        console.dir(cascaderArr);

        this.commodityList[0].cascaderArr = cascaderArr;
      });
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },

    //选择
    chooseShop(val) {
      console.log(val);
      const skuIds = [val.skuId];
      this.sureLoading = true;
      checkProduct(skuIds)
        .then((res) => {
          this.sureLoading = false;
          if (res.code == 1) {
            if (res.data.isHave) {
              this.$message.warning("活动暂不支持选择虚拟套装和影分身商品");
            } else {
              this.form.activityName = val.skuName.substr(0, 15);
              this.form.price = val.jdPrice;
              this.form.wareId = val.categoryId;
              this.form.logo = val.logo;
              this.dialogFormVisible = false;
            }
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.sureLoading = false;
        });
      // this.form.activityName = val.skuName.substr(0, 15);
      // this.form.price = val.jdPrice;
      // this.form.wareId = val.categoryId;
      // this.form.logo = val.logo;
      // this.dialogFormVisible = false;
    },
    searchContent(val) {
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },

    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 1024 * 1.5;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 1.5MB");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;
        this.$refs.upload.$children[1].$el.style.display = "none";
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.form.logo = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    httpRequest() {},
    // 生成规则
    generativerule() {
      console.log("123------>", 123);
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "";
      if (!this.form.activityName) {
        return this.$message.error("请输入礼品名称");
      }
      //活动名称
      if (String(this.form.activityName).length > 0) {
        text1 = "礼品名称：" + this.form.activityName;
      }
      if (this.form.price) {
        text2 = "礼品价值" + this.form.price + "元";
      }
      if (this.form.exchangeTimes) {
        text3 = "每人限兑次数：" + this.form.exchangeTimes + "次";
      } else {
        text3 = "每人限兑次数：不限次数";
      }
      if (this.form.quantityTotal) {
        text4 = "总份数：" + this.form.quantityTotal;
      }
      if(this.tabActive == 9) {
        text3 = `每人限制兑换次数：每日最多可兑换${this.form.exchangeDayTimes || '不限制'}次，活动期间最多可兑换${this.form.exchangeTimes || '不限制'}次`;
        text4 = `活动库存：每日库存${this.form.exchangeNumPerDay || '不限制'}个，活动总库存${this.form.quantityTotal}个`
      }
      if (this.form.startTime && this.form.endTime) {
        text5 = "上下架时间：" + this.form.startTime + "至" + this.form.endTime;
      }
      if (this.level && this.level.length) {
        let levelText = [];
        this.memberLevelList.forEach((item) => {
          if (
            this.level.includes(item.value) &&
            ((!this.isLevelSet && this.form.memberLevelPoints) || item.point)
          ) {
            const obj =
              item.label +
              ":" +
              (this.isLevelSet ? item.point : this.form.memberLevelPoints) +
              "积分";
            levelText.push(obj);
          }
        });
        text6 = "兑换所需等级及积分:" + levelText.splice(",");
      }
      let Arr1 = [text1, text2, text3, text4, text5, text6, text7, text8];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + "。" + "\n";
          newNum = newNum + 1;
        }
      });
      // 1.14迭代 plus会员
      // if(this.ruleDto.plusObject!=0){
      //   newText = newText + newNum + "." + `Plus会员身份：${this.ruleDto.plusObject==1?'Plus会员':'非Plus会员'}` + ";" + "\n";
      // }
      this.form.ruleDescription = newText;
      this.$forceUpdate();
    },

    clearTime() {
      this.form.startTime = "";
      this.form.endTime = "";
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.form.activityName) {
        this.$message.warning("请输入礼品名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.setActivity();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.setActivity();
        });
      }
    },
    //创建礼品兑换活动
    setActivity() {
      if (!this.isDraft) {
        //活动创建限制
        if (!this.form.activityName) {
          this.$message.warning("请输入礼品名称");
          return;
        }
        if (this.butActive == 1 && this.tabActive == 10) {
          this.$message.warning("请添加优惠券");
          return;
        }
        // if (!this.form.price && this.tabActive == 9) {
        //   this.$message.warning("请输入礼品价值");
        //   return;
        // }
        if (!this.form.logo && this.tabActive == 9) {
          this.$message.warning("请添加礼品图片");
          return;
        }
        if (this.form.ruleDTO.exchangeConditions == 1 && this.tabActive == 9) {
          if(!this.form.ruleDTO.orderEndTime || !this.form.ruleDTO.orderEndTime){
            this.$message.warning("请选择下单时间");
            return;
          };
          if(new Date(this.form.ruleDTO.orderEndTime).getTime() > new Date(this.form.ruleDTO.endTime).getTime()){
            this.$message.warning("下单结束时间不能大于活动结束时间");
            return;
          };
          if(this.form.ruleDTO.filterType != 0 && !this.itemListForFilter.length){
            this.$message.warning("请选择指定/排除商品");
            return;
          };
          if(!this.form.ruleDTO.orderPaymentLimit){
            this.$message.warning("请输入订单金额限制");
            return;
          }
          if(this.form.ruleDTO.goShopSetting == 1 && !this.form.ruleDTO.goShopAppId){
            this.$message.warning("请输入小程序AppId");
            return;
          }
          if(this.form.ruleDTO.goShopSetting == 2 && !this.form.ruleDTO.goShopUrl){
            this.$message.warning("请输入下单跳转链接");
            return;
          }
        }

        const ruleDTO = this.form.ruleDTO;
        if (ruleDTO.activityTargetType == 3 && !this.peopleSelected.length) {
          this.$message.warning("请选择指定人群");
          return;
        }
        if (ruleDTO.activityTargetType == "2") {
          if (
            ruleDTO.firstOpenCardTimeType == 1 &&
            !ruleDTO.openCardBeforeDay
          ) {
            this.$message.warning("请完善首次入会时间");
            return;
          }
          if (
            ruleDTO.firstOpenCardTimeType == 2 &&
            (!ruleDTO.openCardStartTime || !ruleDTO.openCardEndTime)
          ) {
            this.$message.warning("请完善首次入会时间");
            return;
          }
          if (
            ruleDTO.lastOrderCompleteTimeType == 1 &&
            (!ruleDTO.lastOrderCompleteStartDay &&
              !ruleDTO.lastOrderCompleteEndDay)
          ) {
            this.$message.warning("请完善购物条件");
            return;
          }
          if (
            ruleDTO.lastOrderCompleteTimeType == 2 &&
            (!ruleDTO.lastOrderCompleteStartTime ||
              !ruleDTO.lastOrderCompleteEndTime)
          ) {
            this.$message.warning("请完善购物条件");
            return;
          }
        }
        if (!this.form.startTime || !this.form.endTime) {
          this.$message.warning("请输入上下架时间");
          return;
        }
        let nowTime = new Date().getTime();
        let start = new Date(this.form.startTime).valueOf();
        let end = new Date(this.form.endTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return;
        }
        if (end < start) {
          this.$message.warning("结束时间不能小于开始时间");
          return;
        }
        if (this.level.length == 0) {
          this.$message.warning("请输入兑换所需等级");
          return;
        }
        if (!this.form.quantityTotal && this.tabActive == 9) {
          this.$message.warning("请输入总份数!");
          return;
        }
        if ((this.form.exchangeDayTimes > this.form.exchangeTimes) && this.tabActive == 9 && this.form.exchangeTimes) {
          this.$message.warning("每天配置限制次数不可大于累计次数!");
          return;
        }
       if ((+this.form.exchangeNumPerDay > +this.form.quantityTotal) && this.tabActive == 9) {
          this.$message.warning("每日库存不能大于活动总库存!");
          return;
        }
        // 兑换所需积分校验
        if (this.isLevelSet) {
          let flag = false;
          this.memberLevelList.forEach((list) => {
            if (!list.point && list.allow) {
              flag = true;
            }
          });
          if (flag) return this.$message.warning("请输入兑换所需积分");
        } else {
          if (!this.form.memberLevelPoints) {
            this.$message.warning("请输入兑换所需积分");
            return;
          }
        }
        if (!this.form.ruleDescription) {
          this.$message.warning("请输入规则说明");
          return;
        }
        if(this.placementPosition.length==0) {
          this.$message.warning("请选择活动投放位置！");
          return
        }
      }
      let obj = {
        activityName: "",
        activityType: 9,
        couponId: 0,
        endTime: "",
        exchangeTimes: null,
        giftType: 0,
        logo: "",
        memberLevelPointsDTOList: [],
        price: 0,
        quantityTotal: 0,
        ruleDescription: "",
        startTime: "",
        title: "",
        wareId: 0,
      };
      obj = this.form;
      if(obj.ruleDTO) {
        obj.ruleDTO.crowdIds = this.peopleSelected.join(",");
        if(obj.ruleDTO.activityTargetType != 2) {
          obj.ruleDTO.allowLevel = "-1";
        } else {
          obj.ruleDTO.allowLevel = obj.ruleDTO.partner.join(",");
        }
        if(obj.ruleDTO.filterType != 0) {
          obj.ruleDTO.skuIdList = this.itemListForFilter.map(v => v.skuId);
        }
      };
      // 处理兑换所需积分
      obj.memberLevelPointsDTOList = this.memberLevelList.map((item) => {
        const checked = this.level.includes(item.value);
        return {
          allow: checked,
          level: item.value,
          levelName: item.label,
          point: checked
            ? this.isLevelSet
              ? item.point
              : this.form.memberLevelPoints
            : 0,
        };
      });
      obj.studentSatus = this.form.ruleDTO.studentSatus || "";
      delete obj.ruleDTO.studentSatus;
      // 处理是否重点活动
      obj.isKeyActivity = this.isKeyActivity;
      obj.placementPosition = this.placementPosition.join(",");
      console.log(obj, "obj");
      if (this.couponTxt.discount != null) {
        obj.price = Number(this.couponTxt.discount);
      } else {
        obj.price = this.form.price;
        obj.title = this.form.activityName;
        obj.wareId = this.form.wareId;
        if (this.form.wareId != null) {
          obj.giftType = 1;
        } else {
          obj.giftType = 2;
        }
      }
      obj.activityName = this.form.activityName;
      obj.activityType = this.tabActive;
      obj.couponId = this.couponId;
      if(this.tabActive==9) {
        obj.cites = this.addressList.length > 0 ? this.addressList.join(",") : ""
      }
      if (this.form.exchangeTimes != null && this.form.exchangeTimes != "") {
        obj.exchangeTimes = Number(this.form.exchangeTimes);
      }
      if (this.form.quantityTotal) {
        obj.quantityTotal = Number(this.form.quantityTotal);
      }
      obj.customerPaperwork = JSON.stringify(this.customerPaperwork);
      // 草稿箱
      if (this.isDraft) {
        obj.status = 5
        if (!obj.couponId) {
          obj.couponId = null;
        }
      } else {
         // 保存正式活动不需要status
         if (obj.status) {
           delete obj.status;
        }
       }

      // 草稿箱编辑-添加活动id
      if (this.isDraftEdit) {
        obj.id = this.valueRow.id;
      }
      if (this.isCopy) {
        delete obj.id;
      }
      // form.quantityTotal
      // return;
      if(this.isEdit) {
        obj.id = this.valueRow.id
        let editAip = changeActivity;
        if(this.valueRow && this.valueRow.status == 2) {
          editAip = updateActivity;
          if(obj.templateId == 0) {
            obj.templateId = null;
          }
        }
        editAip(obj)
        .then((res) => {
          console.log(res, "res");
          if (res && res.id || res.code == 1) {
            this.$router.push({
              name: "throw",
              query: {
                id: res.id || this.valueRow && this.valueRow.id,
                activityType: res.activityType || this.activityData.activityType,
              },
            });
            this.$message.success("修改成功");
          } else {
            this.$message.error(res.message || "修改失败");
          }
        })
        .catch((res) => {});
        return
      }
      if (this.venderType) {
        // debugger
        obj.safeCoupon = this.couponTxt;
        // obj.quantityTotal = obj.safeCoupon.issuedQuantity;
        obj.takeRule = obj.safeCoupon.limitRule;
        obj.quantityTotal = Number(this.form.quantityTotal);
        // obj.safeCoupon.startTime = "2022-01-25"
        // obj.safeCoupon.takeBeginTime = "2022-01-26"
        // obj.safeCoupon.endTime = "2022-02-25"
        // obj.safeCoupon.takeEndTime = "2022-02-24"
        setActivityVenderType(obj).then((res) => {
          if (res && res.code == 1) {
            if (this.isDraft) {
              this.$emit("return", true);
            } else {
              this.memberLevelPointsDTOList = [];
              this.$message.success(res.message);
              // let routeUrl = this.$router.resolve({
              //   path: "/integralCenter/integralMall",
              //   query: { tabAct: 3 },
              // });
              // window.open(routeUrl.href, "_self");
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
            }
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        setActivityList(obj)
          .then((res) => {
            if (res && res.code == 1) {
              if (this.isDraft) {
                this.$emit("return", true);
              } else {
                this.memberLevelPointsDTOList = [];
                this.$message.success(res.message);
                // let routeUrl = this.$router.resolve({
                //   path: "/integralCenter/integralMall",
                //   query: { tabAct: 3 },
                // });
                // window.open(routeUrl.href, "_self");
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
              }
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      }
    },
    //分页事件
    handleSizeChange(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChange(val) {
      this.formShopList.current = val;
      this.getShopList();
    },
  },
};
</script>

<style scoped lang="scss">
.level-wrap {
  display: flex;
  /deep/.el-checkbox-group {
    margin-right: 16px;
  }
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
}

.firststep {
  min-height: 820px;
  box-sizing: border-box;
  padding: 0px 35px 25px;
}
.create_coupons {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  // min-height: 880px;
  .head {
    flex-shrink: 0;
    box-sizing: border-box;
    padding-left: 24px;
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
    font-size: 14px;
    div {
      display: flex;
      align-items: center;
      color: #999;
      cursor: pointer;
      img {
        margin-right: 4px;
      }
    }
    .t {
      margin: 0 20px;
      color: #ccc;
    }
    .txt {
      color: #333;
    }
  }
  .main {
    flex: 1;
    box-sizing: border-box;
    padding: 0px 0 0 24px;
    .addBtn {
      width: 98px !important;
      height: 32px;
      line-height: 28px;
      border: 1px solid #fe4d45;
      color: #fe4d45;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .couponContent {
      height: 130px;
      width: 260px;
      border: 1px solid #dddddd;
      border-radius: 10px;
      position: relative;
      .txtNum {
        position: absolute;
        margin: 25px;
        width: 160px;
      }
      .txtSize {
        margin: 20px 0 0 140px;
        line-height: 22px;
      }
      .time {
        font-size: 12px;
        margin-left: 30px;
        color: #999999;
      }
      .btn {
        display: none;
        opacity: 0;
      }
      &:hover {
        box-shadow: 0px 0px 8px 2px #dddddd;
        .btn {
          display: inline;
          // margin: -17px 0 0 -49px;
          opacity: 1;
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 80px;
          height: 36px;
        }
        .background {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 10px;
          background-color: #fff;
          opacity: 0.7;
        }
      }
    }
    .pContent {
      // display: block;
      float: left;
      width: 250px;
      color: #999999;
    }
    .limitBox {
      display: flex;
      align-items: center;
      .desc {
        margin-left: 32px;
        font-size: 13px;
        color: #999;
        i {
          color: #fe8f8a;
          opacity: 0.8;
        }
      }
    }
    .lastTime {
      color: #333;
    }
    .isLevelSet {
      // display: flex;
      .levelList {
        display: flex;
        flex-wrap: wrap;
        width: 200px;
        float: left;
        .item {
          // width: 50%;
          text-align: right;
          margin-bottom: 16px;
          font-size: 14px;
          color: #333;
        }
      }
      .setBtn {
        width: 115px;
        height: 32px;
        line-height: 28px;
        // margin-left: 20px;
        border: 1px solid #fe4d45;
        color: #fe4d45;

        background: rgba(254, 77, 69, 0.1);
        font-size: 13px;
        &:hover {
          background-color: #fe4d45;
          color: #fff;
        }
      }
    }
    .generate {
      border: 1px solid #fe4d45;
      background: rgba(254, 77, 69, 0.1);
      color: #fe4d45;
      width: 76px;
      height: 28px;
      line-height: 24px;
    }
    .txt {
      margin-left: 12px;
      color: #999;
      font-size: 13px;
    }
  }
  .foot {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    // width: 100%;
    // position: absolute;
    bottom: -150px;
    justify-content: flex-start;
    height: 80px;
    border-top: 1px solid #f6f6f6;
    margin-left: 88px;
  }
  p {
    margin: 0;
  }
  button {
    height: 34px;
    line-height: 32px;
    text-align: center;
    // border: none;
    // background-color: white;
    outline: none;
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s;
  }
}
.pd20 {
  padding: 20px 20px 16px;
}
</style>

<style lang="scss">
.big-box-preview {
  width: 375px;
  height: 700px;
  box-shadow: 0 4px 20px 0 rgba(18, 10, 60, .1490);
  border-radius: 8px;
  box-sizing: content-box;
  overflow: hidden;
  overflow-y: auto;
  padding: 10px;
  margin-left: 40px;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    width: 0 !important;
  }
  -ms-overflow-style: none;
  .scroll-box {
    background-size: 100% 825px;
    height: 825px;
    scrollbar-width: none;
    .goodsc-car-line{
      width: 100%;
      margin-top: 10px;
      margin-bottom: 12px;
      height: 1px;
      border-top: 1px solid #C0C0C0;
      border-style: dashed;
    }
    .goods-des {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 12px;
      & > span {
        font-size: 12px;
        &:first-child {
          color: #999999;
        }
        &:last-child {
          color: #666666;
        }
      }
    }
    .rule-title {
      margin-left: 15px;
      margin-top: 21px;
      font-weight: bold;
      font-size: 15px;
      color: #0B0D0F;
    }
    .handler-btns {
      height: 44px;
      margin: 30px 15px 0;
      display: flex;
      align-items: center;
      & > div {
        font-size: 15px;
        text-align: center;
        line-height: 44px;
        &:first-child {
          width: 105px;
          height: 100%;
          border-radius: 4px;
          border: 1px solid #000000;
          color: #000000;
        }
        &:last-child {
          flex: 1;
          margin-left: 10px;
          background: #000000;
          border-radius: 4px;
          border: 1px solid #000000;
          color: #FFFFFF;
          font-weight: bold;
        }
      }
    }
    .rule-infos {
      margin: 8px 15px 0;
      height: 102px;
      overflow-y: auto;
      color: #666666;
      font-size: 12px;
      line-height: 16px;
      // 隐藏滚动条
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      -ms-overflow-style: none;
    }
    .goods-info {
      height: 170px;
      margin: 290px 16px 0;
      padding: 12px;
      background: url("https://cdn-image.yucrm.cn/2cdba1ce04b54a29b6a65ea6a8ca5773.png") no-repeat;
      background-size: 100% 100%;
      .goods-detail {
        display: flex;
        .goods-detail-img {
          width: 90px;
          height: 90px;
          margin-right: 12px;
          border-radius: 4px;
          overflow: hidden;
          & > img {
            width: 100%;
            height: 100%;
          }
        }
        .goods-detail-info {
          margin-left: 12px;
          flex: 1;
          .goods-detail-name {
            width: 180px;
            font-size: 16px;
            line-height: 23px;
            color: #000000;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .goods-detail-amount {
            display: inline-block;
            margin-top: 6px;
            padding: 2px 4px;
            font-size: 14px;
            line-height: 1;
            background: #FBEDD6;
          }
          .goods-detail-price-box {
            display: flex;
            align-items: flex-end;
            margin-top: 20px;
            .point {
              font-size: 22px;
              color: #E14210;
              font-weight: bold;
            }
            .old-price {
              margin-left: 10px;
              font-weight: 400;
              font-size: 13px;
              color: #9E9E9E;
              text-decoration-line: line-through;
            }
          }
        }
      }
    }
  }
  // overflow: hidden;
  .big-box-img {
    border-radius: 24px;
    width: 283px;
    height: 755px;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}
.activityPageSettings-preview {
  padding: 20px;
}
.activityPageSettings-preview .title{
  margin: 10px 0;
  text-align: center;
  color: #999;
}
</style>